import React, { createContext, useContext, useCallback, useEffect, useRef } from 'react';
import NotificationSystem from 'react-notification-system';


const NotificationContext = createContext();
let externalNotify = null;

export const useNotification = () => useContext(NotificationContext);
export const getNotify =() => externalNotify;

export const NotificationContextProvider = ({ children }) => {
  const notificationRef = useRef(null);

  const notify =  useCallback(({ message, level , position = 'br', autoDismiss = 10, ...rest }) => {
    const title = level === 'success' ? 'Success': 'Error';

    notificationRef.current?.addNotification({
      title,
      message,
      level,
      position,
      autoDismiss,
      ...rest,
    });
  }, []);
  useEffect(() => {
    externalNotify = notify;
  }, []);
  return (
    <NotificationContext.Provider value={notify}>
      <NotificationSystem ref={notificationRef} />
      {children}
    </NotificationContext.Provider>
  );
};
